import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('conceal_items_in_meatball_menu_ga_fg');
	},
};
